<div class="plan-draw">
  <!-- Header -->
  <div class="draw-header">
    <button mat-icon-button (click)="cancel()" aria-label="Zurück" matTooltip="Zurück (ohne Speichern)">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <h1>{{ isEditMode ? 'Plan zeichnen bearbeiten' : 'Plan zeichnen' }}</h1>
    <span class="spacer"></span>
    <button mat-stroked-button (click)="cancel()" [disabled]="isSaving" matTooltip="Abbrechen und zurück">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isSaving || showStartChoice"
            matTooltip="Plan speichern (Zeichnung, Hintergrund und Indikatoren)">
      <mat-icon>save</mat-icon>
      Speichern
    </button>
  </div>

  <!-- Toolbar -->
  <div class="draw-toolbar" *ngIf="!showStartChoice">
    <div class="tool-group">
      <button mat-icon-button class="tool-btn" [class.active]="tool === 'pan'" (click)="setTool('pan')"
              matTooltip="Auswählen, Verschieben & Zoomen – Element antippen zum Auswählen und Vergrößern/Verkleinern">
        <mat-icon>pan_tool</mat-icon>
      </button>
      <button mat-icon-button class="tool-btn" [class.active]="tool === 'pen' && !gridMode" (click)="setPen(false)"
              matTooltip="Stift – frei zeichnen (beliebige Formen)">
        <mat-icon>edit</mat-icon>
      </button>
      <button mat-icon-button class="tool-btn" [class.active]="tool === 'pen' && gridMode" (click)="setPen(true)"
              matTooltip="Raster-Stift – nur waagrechte, senkrechte & diagonale Linien (am Raster ausgerichtet)">
        <mat-icon>border_color</mat-icon>
      </button>
      <button mat-icon-button class="tool-btn" [class.active]="tool === 'eraser'" (click)="setTool('eraser')"
              matTooltip="Radierer – einzelnes Element zum Löschen antippen">
        <mat-icon>delete_outline</mat-icon>
      </button>
    </div>

    <span class="separator"></span>

    <div class="tool-group">
      <button mat-icon-button class="tool-btn" (click)="addShape('rect-landscape')" matTooltip="Rechteck (quer) einfügen">
        <mat-icon>crop_landscape</mat-icon>
      </button>
      <button mat-icon-button class="tool-btn" (click)="addShape('rect-portrait')" matTooltip="Rechteck (hoch) einfügen">
        <mat-icon>crop_portrait</mat-icon>
      </button>
      <button mat-icon-button class="tool-btn" (click)="addShape('square')" matTooltip="Quadrat einfügen">
        <mat-icon>crop_square</mat-icon>
      </button>
      <button mat-icon-button class="tool-btn" (click)="addShape('wall-h')" matTooltip="Linie waagrecht einfügen (nur Länge änderbar)">
        <mat-icon>horizontal_rule</mat-icon>
      </button>
      <button mat-icon-button class="tool-btn" (click)="addShape('wall-v')" matTooltip="Linie senkrecht einfügen (nur Länge änderbar)">
        <mat-icon style="transform: rotate(90deg);">horizontal_rule</mat-icon>
      </button>
      <button mat-icon-button class="tool-btn" (click)="addShape('l-left')" matTooltip="L-Form (links) einfügen">
        <span class="shape-letter">L</span>
      </button>
      <button mat-icon-button class="tool-btn" (click)="addShape('l-right')" matTooltip="L-Form (rechts) einfügen">
        <span class="shape-letter flip">L</span>
      </button>
      <button mat-icon-button class="tool-btn" (click)="addShape('door')" matTooltip="Tür einfügen">
        <mat-icon>meeting_room</mat-icon>
      </button>
    </div>

    <span class="separator"></span>

    <div class="tool-group">
      <button mat-icon-button class="tool-btn" (click)="openIndicatorPicker()"
              matTooltip="Indikator platzieren oder neuen Indikator erstellen">
        <mat-icon>add_location</mat-icon>
      </button>
    </div>

    <span class="separator"></span>

    <div class="tool-group">
      <button
        *ngFor="let c of colors"
        class="color-swatch"
        [class.active]="strokeColor === c"
        [style.background]="c"
        (click)="setColor(c)"
        [matTooltip]="'Zeichenfarbe: ' + colorLabel(c)"
        [attr.aria-label]="'Farbe ' + colorLabel(c)"></button>
    </div>

    <span class="separator"></span>

    <div class="tool-group">
      <button mat-icon-button class="tool-btn" color="warn" (click)="clearDrawing()"
              matTooltip="Gesamte Zeichnung löschen (Indikatoren bleiben erhalten)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <!-- Stage -->
  <div class="stage-wrapper">
    <div #konvaHost class="konva-host"></div>

    <!-- Start-mode choice -->
    <div class="start-overlay" *ngIf="showStartChoice">
      <mat-icon style="font-size:48px;width:48px;height:48px;color:#1d4ed8;">draw</mat-icon>
      <h2>Wie möchten Sie starten?</h2>

      <mat-form-field *ngIf="needsSektionPicker" appearance="outline" style="width:100%;max-width:340px;">
        <mat-label>Sektion auswählen</mat-label>
        <mat-select [(ngModel)]="sektionId">
          <mat-option *ngFor="let s of sektionChoices" [value]="s.id">{{ s.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <div class="start-choices">
        <button mat-raised-button color="primary" (click)="startBlank()" [disabled]="needsSektionPicker && !sektionId">
          <mat-icon>description</mat-icon>
          Leer zeichnen
        </button>
        <button mat-stroked-button (click)="fileInput.click()" [disabled]="needsSektionPicker && !sektionId">
          <mat-icon>photo_camera</mat-icon>
          Foto verwenden
        </button>
      </div>
    </div>

    <!-- Saving overlay -->
    <div class="saving-overlay" *ngIf="isSaving">
      <mat-spinner diameter="42" color="accent"></mat-spinner>
      <p>Speichere Plan...</p>
    </div>
  </div>

  <!-- Footer -->
  <div class="draw-footer" *ngIf="!showStartChoice">
    <button mat-stroked-button (click)="cancel()" [disabled]="isSaving">Abbrechen</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isSaving">
      <mat-icon>save</mat-icon>
      Speichern
    </button>
  </div>
</div>

<input
  #fileInput
  type="file"
  accept="image/*"
  capture="environment"
  class="hidden-file-input"
  (change)="onPhotoSelected($event)" />
